import { Injectable } from '@angular/core';
import {
  SectorTaskGroupingCreateBody,
  SectorTaskGroupingRepository,
  SectorTaskGroupingUpdateBody,
} from '@app/domain';
import { Observable } from 'rxjs';
import { SectorTaskGroupingService } from '../api-clients';

@Injectable()
export class SectorTaskGroupingRepositoryImpl
  implements SectorTaskGroupingRepository
{
  constructor(
    private readonly _sectorTaskGroupingService: SectorTaskGroupingService
  ) {}

  createOrUpdateSectorTaskGrouping(
    sectorTaskGroupingCreateBody:
      | SectorTaskGroupingCreateBody
      | SectorTaskGroupingUpdateBody,
    isUpdate?: boolean
  ): Observable<void> {
    return this._sectorTaskGroupingService.createOrUpdateSectorTaskGrouping(
      sectorTaskGroupingCreateBody,
      isUpdate
    );
  }

  deleteSectorTaskGrouping(taskGroupId: number): Observable<void> {
    return this._sectorTaskGroupingService.deleteSectorTaskGrouping(
      taskGroupId
    );
  }

  removeTaskFromTaskGroup(
    taskGroupId: number,
    taskTemplateId: number
  ): Observable<void> {
    return this._sectorTaskGroupingService.removeTaskFromTaskGroup(
      taskGroupId,
      taskTemplateId
    );
  }
}
